import { InjectionToken } from '@angular/core';
import { CommonsGenericProxy } from 'ib-web-commons/app/core/proxies/ib-commons-generic-proxy';
import { upgradeAJSServiceProvider } from 'ib-web-commons/utils'; 
export const AJSGiftCardsCommonsGenericProxy = new InjectionToken('CommonsGenericProxy');
export const AJSGiftCardsCommonsGenericProxyProvider = upgradeAJSServiceProvider('CommonsGenericProxy', AJSGiftCardsCommonsGenericProxy);
export interface GiftCardsCommonsGenericProxyType extends CommonsGenericProxy {
    initKeepAlive()
}
